import "whatwg-fetch";
import { toast } from "react-toastify";
import { decode } from "base64-arraybuffer";
import { store } from "app";
import { handleLogout, refreshToken } from "containers/Login/reducer";
import { isEnabled } from "utils/featureFlags";
import { updateError } from "containers/Errors/reducer";
export function getIsDemoAccount() {
    return isEnabled("demo-no-error");
}
export class RequestError extends Error {
    response;
    status;
    constructor(response, message) {
        super(message); // 'Error' breaks prototype chain here
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
        this.response = response;
    }
}
export function getAPIToken() {
    const lookerSDK = window.looker_SDK;
    const lookerKeys = window.looker_aKeys;
    if (sessionStorage !== undefined && lookerSDK === undefined) {
        const sessionKey = sessionStorage.getItem("aible_auth_token");
        if (sessionKey) {
            return sessionKey;
        }
    }
    if (localStorage !== undefined && lookerSDK === undefined) {
        const storageToken = localStorage.getItem("aible_auth_token");
        if (storageToken) {
            return storageToken;
        }
    }
    if (lookerKeys !== undefined && lookerKeys.aible_auth_token !== undefined && lookerKeys.aible_auth_token !== null) {
        const lookerToken = lookerKeys.aible_auth_token;
        if (lookerToken) {
            return lookerToken;
        }
    }
    const stateToken = store?.getState()?.auth?.aible_auth_token;
    if (stateToken) {
        return stateToken;
    }
    return undefined;
}
export function getIAPToken() {
    const lookerSDK = window.looker_SDK;
    const lookerKeys = window.looker_aKeys;
    if (sessionStorage !== undefined && lookerSDK === undefined) {
        const sessionKey = sessionStorage.getItem("aible_iap_token");
        if (sessionKey) {
            return sessionKey;
        }
    }
    if (localStorage !== undefined && lookerSDK === undefined) {
        const localToken = localStorage.getItem("aible_iap_token");
        if (localToken) {
            return localToken;
        }
    }
    if (lookerKeys !== undefined && lookerKeys.aible_iap_token !== undefined && lookerKeys.aible_iap_token !== null) {
        const lookerToken = lookerKeys.aible_iap_token;
        if (lookerToken) {
            return lookerToken;
        }
    }
    const stateToken = store?.getState()?.auth?.aible_iap_token;
    if (stateToken) {
        return stateToken;
    }
    return undefined;
}
export function getUserToken() {
    const lookerSDK = window.looker_SDK;
    const lookerKeys = window.looker_aKeys;
    if (sessionStorage !== undefined && lookerSDK === undefined) {
        const sessionKey = sessionStorage.getItem("aible_user_token");
        if (sessionKey) {
            return sessionKey;
        }
    }
    if (localStorage !== undefined && lookerSDK === undefined) {
        const localToken = localStorage.getItem("aible_user_token");
        if (localToken) {
            return localToken;
        }
    }
    if (lookerKeys !== undefined && lookerKeys.aible_user_token !== undefined && lookerKeys.aible_user_token !== null) {
        const lookerToken = lookerKeys.aible_user_token;
        if (lookerToken) {
            return lookerToken;
        }
    }
    const stateToken = store.getState().auth.aible_user_token;
    if (stateToken) {
        return stateToken;
    }
    return undefined;
}
export function getTokenExpires() {
    const lookerSDK = window.looker_SDK;
    const lookerKeys = window.looker_aKeys;
    if (sessionStorage !== undefined && lookerSDK === undefined) {
        const sessionKey = sessionStorage.getItem("aible_token_expires");
        if (sessionKey) {
            return sessionKey !== undefined ? Number(sessionKey) : sessionKey;
        }
    }
    if (localStorage !== undefined && lookerSDK === undefined) {
        const localExpiration = localStorage.getItem("aible_token_expires");
        if (localExpiration) {
            return localExpiration;
        }
    }
    if (lookerKeys !== undefined &&
        lookerKeys.aible_token_expires !== undefined &&
        lookerKeys.aible_token_expires !== null) {
        const lookerExpiration = lookerKeys.aible_token_expires;
        if (lookerExpiration) {
            return lookerExpiration;
        }
    }
    const stateExpiration = store.getState().auth.aible_token_expires;
    if (stateExpiration) {
        return stateExpiration;
    }
    return undefined;
}
export function getUserTokenExpires() {
    const lookerSDK = window.looker_SDK;
    const lookerKeys = window.looker_aKeys;
    if (sessionStorage !== undefined && lookerSDK === undefined) {
        const sessionKey = sessionStorage.getItem("aible_user_token_expires");
        if (sessionKey) {
            return sessionKey !== undefined ? Number(sessionKey) : sessionKey;
        }
    }
    if (localStorage !== undefined && lookerSDK === undefined) {
        const localUserExpiration = localStorage.getItem("aible_user_token_expires");
        if (localUserExpiration) {
            return localUserExpiration;
        }
    }
    if (lookerKeys !== undefined &&
        lookerKeys.aible_user_token_expires !== undefined &&
        lookerKeys.aible_user_token_expires !== null) {
        const lookerUserExpiration = lookerKeys.aible_user_token_expires;
        if (lookerUserExpiration) {
            return lookerUserExpiration;
        }
    }
    const stateUserExpiration = store.getState().auth.aible_user_token_expires;
    if (stateUserExpiration) {
        return stateUserExpiration;
    }
    return undefined;
}
export function getAccountIdFromLastLogin() {
    const lookerSDK = window.looker_SDK;
    const lookerKeys = window.looker_aKeys;
    return localStorage !== undefined && lookerSDK === undefined
        ? localStorage.getItem("aible_account_id")
        : lookerKeys !== undefined && lookerKeys.aible_account_id !== undefined && lookerKeys.aible_account_id !== null
            ? lookerKeys.aible_account_id
            : store === undefined
                ? undefined
                : store.getState().aible_account_id;
}
/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
export function parseJSON(response) {
    const contentType = response.headers.get("content-type");
    return contentType && contentType.indexOf("application/json") !== -1 ? response.json() : response.text();
}
export function parseJSONDownload(response) {
    const contentType = response.headers.get("content-type");
    const contentDis = response.headers.get("content-disposition");
    const retRequest = contentType && contentType.indexOf("application/json") !== -1 ? response.json() : response.text();
    const name = contentDis && contentDis.indexOf('filename="') !== -1
        ? contentDis.slice(contentDis.indexOf('filename="') + 10, -1)
        : "ScoredDataset.csv";
    return {
        data: retRequest,
        fileName: name
    };
}
/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
export function checkStatus(response, noLogout, noErrorToast, isLogoutCheck) {
    if (response.status === 0) {
        return Promise.resolve(response);
    }
    if (response.status === 403 && !noLogout) {
        if (isLogoutCheck) {
            console.log("Got forbidden. Logging out.");
            store.dispatch(handleLogout());
        }
        else {
            store.dispatch(refreshToken(false, true));
        }
    }
    // Added 428 exception for OAuth schema monitor response
    if ((response.status >= 200 && response.status < 300) || response.status == 428) {
        return Promise.resolve(response);
    }
    const contentType = response?.headers?.get("content-type");
    const token_expire_epoch = response?.headers?.get("X-Aible-Token-Expire-Epoch"); //seconds
    const token_expire_ttl = response?.headers?.get("X-Aible-Token-TTL"); // seconds
    const currentTimeUTC = +new Date() / 1000; //seconds
    if (typeof token_expire_epoch === "string" && token_expire_ttl === "string") {
        const token_expire_epoch_seconds = parseFloat(token_expire_epoch);
        const token_expire_ttl_seconds = parseFloat(token_expire_ttl);
        if (token_expire_ttl_seconds < 300) {
            let warning = `[authentication] [${response?.url}] token expires at ${token_expire_epoch_seconds} UTC (currently ${currentTimeUTC})`;
            if (token_expire_ttl_seconds < 120) {
                console.warn(warning);
            }
            else {
                console.debug(warning);
            }
        }
    }
    const errorResponse = contentType && contentType.indexOf("application/json") !== -1 ? response.json() : response.text();
    const error = new RequestError(errorResponse, response.statusText);
    return error.response.then((data) => {
        error.message = data;
        error.status = response.status;
        if ((typeof data === "string" && data.indexOf("<html>") !== -1) ||
            (data && data.message && typeof data.message === "string" && data.message.indexOf("<html>") !== -1)) {
            error.message = "Oops! Something went wrong.";
        }
        if (response.status === 403) {
            throw error;
            return;
        }
        if (response.status >= 500 && response.status <= 504) {
            error.message = "There was an error in processing your request. Please try again.";
            throw error;
            return;
        }
        //silences toast for login page but still throws error
        if (response.url === "https://api-dev.aiplusi.com/v1/login/password" ||
            response.url === "https://api-dev.aiplusi.com/v1/login" ||
            response.url === "https://pigeon-dev.aiplusi.com/login") {
            throw error;
            return;
        }
        let errorArray = data;
        if (!Array.isArray(data)) {
            errorArray = [
                {
                    ...data
                }
            ];
        }
        return errorArray
            ?.filter((d) => {
            const emailSuccess = d?.key === "SENT_INVITE_TO_FOLDER_TO_NEW_USER";
            if (emailSuccess) {
                toast(d?.message, {
                    type: toast.TYPE.SUCCESS,
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 5000
                });
                return false;
            }
            return true;
        })
            .map((d) => {
            const errorMessage = d?.message;
            switch (errorMessage) {
                case "Unable to find any Trainings!":
                case "Unable to find any Deployments!":
                case "Unable to find any Datasets!":
                case "Unable to find any Tags!":
                case "Unable to find any Language Model Artifacts!":
                case "Endpoint request timed out":
                case "You have to DELETE the pending rule fit.":
                    throw error;
                default:
                    // Don't show error messages in these situations
                    if (!noErrorToast && Boolean(errorMessage) && d.key !== "WRONG_APP_DOMAIN" && !getIsDemoAccount()) {
                        toast(errorMessage, {
                            type: toast.TYPE.ERROR,
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 5000
                        });
                        store.dispatch(updateError(errorMessage));
                    }
                    throw error;
            }
        });
    });
}
export function rawRequest(url, options, disableAuth = false) {
    const headers = new Headers(options?.headers ?? {});
    if (url.includes("/v1/login/create_bulk")) {
        headers.set("Content-Type", "text/csv");
    }
    if (disableAuth === false) {
        const iapToken = getIAPToken();
        if (iapToken && (!headers.has("Proxy-Authorization") || !headers.get("Proxy-Authorization")?.includes(iapToken))) {
            headers.set("Proxy-Authorization", "Bearer " + iapToken);
        }
        if (!headers.has("Authorization")) {
            headers.set("Authorization", "Bearer " + getAPIToken());
        }
        // console.log('-=-=-=- headers')
        // for (const pair of headers.entries()) {
        //   console.log(pair[0], pair[1]);
        // }
    }
    return fetch(url, { ...options, headers: headers });
}
/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default function request(url, options, disableAuth = false, noLogout, noErrorToast, privateKey, isLogoutCheck) {
    return v2Request(url, { options, disableAuth, noLogout, noErrorToast, privateKey, isLogoutCheck });
}
const defaultV2RequestOptions = {
    disableAuth: false
};
export function v2Request(url, options = defaultV2RequestOptions) {
    const opts = { ...defaultV2RequestOptions, ...options };
    return rawRequest(url, opts.options, opts.disableAuth)
        .then((response) => decryptResponse(response, opts.privateKey))
        .then((response) => checkStatus(response, opts.noLogout, opts.noErrorToast, opts.isLogoutCheck))
        .then((response) => parseJSON(response));
}
export function requestRaw(url, options, disableAuth = false, noLogout, noErrorToast, privateKey, isLogoutCheck) {
    return v2RequestRaw(url, { options, disableAuth, noLogout, noErrorToast, privateKey, isLogoutCheck });
}
export function v2RequestRaw(url, options = defaultV2RequestOptions) {
    const opts = { ...defaultV2RequestOptions, ...options };
    return rawRequest(url, opts.options, opts.disableAuth).then((response) => decryptResponse(response, opts.privateKey));
}
export function downloadRequest(url, options, disableAuth = false) {
    return rawRequest(url, options, disableAuth)
        .then(checkStatus)
        .then((response) => parseJSONDownload(response));
}
// ARJ: The decryption with our private key hat dance using RSA b/c it's built in
// function to convert from ArrayBuffer/Array<int> into a string
export function ab2str(buf) {
    // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/exportKey tutorial
    return String.fromCharCode.apply(null, Array.from(new Uint8Array(buf)));
}
export function str2ab(str) {
    const bufView = new Uint8Array(str.length);
    for (let i = 0, strLen = str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return bufView;
}
function indexOf(array, needle) {
    let needleIndex = 0;
    for (let index = 0; index < array.length; index++) {
        const char = array[index];
        if (needleIndex > 0 && char != needle[needleIndex]) {
            needleIndex = 0;
        }
        else if (char == needle[needleIndex]) {
            needleIndex++;
        }
        if (needleIndex == needle.length) {
            // match!
            return index - needleIndex + 1;
        }
    }
    return -1;
}
function* iter_chunked_by(delimiter, buffer) {
    let data = new Uint8Array(buffer);
    const arrayDelimiter = str2ab(delimiter);
    while (data.length > 0) {
        const index = indexOf(data, arrayDelimiter);
        if (index == -1) {
            if (data.length > 0) {
                throw new Error("Truncated stream!");
            }
            break;
        }
        // parse the base10 number string
        const lengthStr = Array.prototype.map.call(data.slice(0, index), (ord) => String.fromCharCode(ord)).join("");
        const length = parseInt(lengthStr, 10);
        data = data.slice(index + delimiter.length);
        const chunk = data.slice(0, length);
        if (chunk.length < length) {
            throw new Error("Truncated stream!");
        }
        yield chunk;
        data = data.slice(length + delimiter.length);
    }
}
export function verifyAndAssertValid(key, signature, data) {
    return window.crypto.subtle
        .verify({
        name: "RSA-PSS",
        saltLength: 32
    }, key, decode(signature), str2ab(data))
        .then((isValid) => {
        if (!isValid) {
            throw new Error("Verification Failed!");
        }
    });
}
// decrypt function for incoming cipher text
function decryptRSAChunked(privateKey, serverPublicKey, content) {
    const contentChunks = [];
    for (const chunk of iter_chunked_by("\r\n", content)) {
        contentChunks.push(chunk);
    }
    return Promise.all(contentChunks.flatMap((c) => window.crypto.subtle.decrypt({ name: "RSA-OAEP" }, privateKey, c)))
        .then((chunks) => new Blob(chunks).text())
        .then((body) => {
        if (body.length == 0) {
            return "";
        }
        const index = body.lastIndexOf(".");
        const [body_content, body_signature] = [body.slice(0, index), body.slice(index + 1)];
        return verifyAndAssertValid(serverPublicKey, body_signature, body_content).then(() => body_content);
    })
        .catch((e) => {
        console.log(e);
        throw e;
    });
}
function parseSignedValue(signed_value) {
    const index = signed_value.lastIndexOf(".");
    const signature = signed_value.slice(index + 1);
    const value = signed_value.startsWith("base64,")
        ? atob(signed_value.slice("base64,".length, index))
        : signed_value.slice(0, index);
    return [value, signature];
}
function decryptBody(privateKey, publicKey, options, body) {
    switch (options.encoding) {
        case "rsa-chunked":
            return decryptRSAChunked(privateKey, publicKey, body);
    }
    throw new Error(`Unrecognized encoding: ${options.encoding}`);
}
export function importRsaPublicForVerification(pem) {
    // fetch the part of the PEM string between header and footer
    pem = pem.trim();
    const pemHeader = "-----BEGIN PUBLIC KEY-----";
    const pemFooter = "-----END PUBLIC KEY-----";
    if (pem.startsWith(pemHeader)) {
        pem = pem.substring(pemHeader.length);
    }
    if (pem.endsWith(pemFooter)) {
        pem = pem.substring(0, pem.length - pemFooter.length - 1);
    }
    // base64 decode the string to get the binary data
    const binaryDerString = atob(pem);
    // convert from a binary string to an ArrayBuffer
    const binaryDer = str2ab(binaryDerString);
    return window.crypto.subtle.importKey("spki", binaryDer, {
        name: "RSA-PSS",
        hash: "SHA-256"
    }, true, ["verify"]);
}
// ARJ: Expected that Armen API will read the public key at request header ``Aible-Client-PublicKey`` and encrypt the response body back using it
// ARJ: Expected thatThe Armen API will response with the header `Aible-Client-PublicKeyHash: sha1@{hashlib.sha1(public_key.public_bytes(), 'pem').hexdigest()}`
// ARJ: This means the body will be an encrypted stream!
function decryptResponse(response, privateKey) {
    const content_encryption = response?.headers?.get("Content-Encryption");
    if (content_encryption != null) {
        console.log("HERE!");
    }
    if (!content_encryption || privateKey === undefined) {
        return Promise.resolve(response);
    }
    const encryptionOptions = {};
    for (const element of content_encryption.split(";")) {
        const index = element.indexOf("=");
        if (index > -1) {
            const [key, value] = [element.slice(0, index), element.slice(index + 1)];
            encryptionOptions[key] = value;
        }
        else {
            encryptionOptions[element] = "";
        }
    }
    const rawResponsePublicKey = encryptionOptions["response-public-key"];
    const index = rawResponsePublicKey.lastIndexOf(".");
    const decodedPublicKey = rawResponsePublicKey.startsWith("base64,")
        ? atob(rawResponsePublicKey.slice("base64,".length, index))
        : rawResponsePublicKey.slice(0, index);
    const decodedPublicKeySignature = rawResponsePublicKey.slice(index + 1);
    var decodedContentType = "";
    var contentTypeSignature = "";
    const rawReponseContentType = encryptionOptions["response-content-type"]; // possible null or empty
    const hasSignedContentType = rawReponseContentType !== null && rawReponseContentType != "";
    if (hasSignedContentType) {
        [decodedContentType, contentTypeSignature] = parseSignedValue(rawReponseContentType);
        // ARJ: Todo - verify contentTypeSignature (it's left as-is from the request which is b64ed)
    }
    return importRsaPublicForVerification(decodedPublicKey)
        .then((publicKey) => verifyAndAssertValid(publicKey, decodedPublicKeySignature, decodedPublicKey)
        .then(() => response.arrayBuffer())
        .then((body) => decryptBody(privateKey, publicKey, encryptionOptions, body)))
        .then((body) => {
        const new_headers = new Headers();
        for (const [key, value] of response.headers) {
            if (key.toLowerCase() == "content-length") {
                new_headers.append(key, body.length.toString());
            }
            else if (key.toLowerCase() == "content-type" && hasSignedContentType && decodedContentType != "") {
                new_headers.append(key, decodedContentType);
            }
            else {
                new_headers.append(key, value);
            }
        }
        return new Response(body, {
            status: response.status,
            statusText: response.statusText,
            headers: new_headers
        });
    })
        .catch((e) => {
        console.log(e);
        throw e;
    });
}
